export interface ObjectToStore {
	data: string;
	ttl: number;
}
